import { Options as useSchedulesOptions, Props, useSchedules } from 'hooks/queries/workspaces/schedules/useSchedules'
import { Response } from 'request-dot-js'
import { TransformedBrandPlanScheduleListItem } from 'screens/BrandKits/components/BrandPlanTimeline/Types'
import dayjs from 'dayjs'
import { transformSchedule } from 'screens/BrandKits/components/BrandPlanTimeline/useTransformedBrandPlanSchedules'
import { useCurrentBrandPlan } from 'hooks/queries/brandPlans/useCurrentBrandPlan'
import { BrandPlanStrategyType } from 'types'
import { SchedulesData } from 'hooks/queries/workspaces/schedules/types'

export interface Options extends Omit<useSchedulesOptions<Response<SchedulesData>>, 'select'> {}

export const useContentPlanSchedules = (props?: Props, options?: Options) => {
  const { data: brandPlan } = useCurrentBrandPlan({ cacheTime: 5 * 60 * 1000 })
  const isCampaigns = !!brandPlan && brandPlan.strategy_type !== BrandPlanStrategyType.Evergreen
  return useSchedules<Response<{ schedules: TransformedBrandPlanScheduleListItem[] }>>(
    {
      orderBy: 'start_date',
      orderDirection: 'asc',
      items: 15,
      startDate: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
      brandPlanId: isCampaigns ? undefined : brandPlan?.id,
      ...props,
    },
    {
      select: (data) => {
        return {
          ...data,
          pages: data.pages.map((page) => ({
            ...page,
            data: {
              ...page.data,
              schedules: page.data.schedules.map(transformSchedule),
            },
          })),
        }
      },
      enabled: !!brandPlan,
      ...options,
    },
  )
}
